import { Component, Input, OnInit, inject } from "@angular/core";
import { finalize, map } from "rxjs/operators";
import { CstFileViewerService } from "src/app/common-components/file-viewers/services/file-viewer.service";
import { FileHelper } from "src/app/helpers";
import {
  FormularImageMetaDto,
  FormulareClientProvider,
} from "src/app/web-api/web-api";

@Component({
    selector: "app-task-formular-images-gallery",
    templateUrl: "./form-images-gallery.component.html",
    styleUrls: ["./form-images-gallery.component.scss"],
    standalone: false
})
export class TaskFormImagesGalleryComponent implements OnInit {
  private _client = inject(FormulareClientProvider);
  private _fileViewer = inject(CstFileViewerService);

  private _formID = "";
  private _onInitExecuted = false;

  public loading = false;

  public groups: [string, FormularImageMetaDto[]][] = null;

  @Input() set formID(value: string) {
    this._formID = value;
    if (this._onInitExecuted) {
      this.refreshFormPictures();
    }
  }
  get formID() {
    return this._formID;
  }

  ngOnInit() {
    if (this._formID) {
      this.refreshFormPictures();
    }
    this._onInitExecuted = true;
  }

  public refreshFormPictures() {
    this.loading = true;
    this.groups = null;
    this._client
      .formularImagesGet([this._formID])
      .pipe(
        finalize(() => (this.loading = false)),
        map((result) => {
          return result.reduce((map, obj) => {
            if (!map[obj.groupLabel]) {
              map[obj.groupLabel] = [];
            }
            map[obj.groupLabel].push(obj);
            return map;
          }, {} as { [key: string]: FormularImageMetaDto[] });
        })
      )
      .subscribe((x) => {
        this.groups = Array.from(Object.entries(x));
      });
  }

  public onImageDisplay(meta: FormularImageMetaDto) {
    this._fileViewer.tryDisplayUrl(
      this.getImageSrcUri(meta),
      this.getImageFilename(meta),
      "image"
    );
  }
  public onImageDownload(meta: FormularImageMetaDto) {
    fetch(this.getImageSrcUri(meta)).then(async (x) => {
      FileHelper.DownloadFile(
        await x.blob(),
        this.getImageFilename(meta, FileHelper.getFileExtension(x.headers))
      );
    });
  }

  public getImageSrcUri(meta: FormularImageMetaDto, size: number = null) {
    return `/api/Formular/Formulare/${meta.formularID}/Images/${meta.imageID}${
      size ? `?size=${size}` : ""
    }`;
  }

  public getImageFilename(meta: FormularImageMetaDto, ext: string = "") {
    let filename = meta.filename;
    if (!filename) {
      filename = `${FileHelper.sanitizeFilename(meta.groupLabel, true)}_${meta.imageID}${ext}`;
    }
    return filename;
  }
}
